import Splide from "@splidejs/splide";

if(typeof(document.querySelector('.slide-home.splide')) != 'undefined' && document.querySelector('.slide-home.splide') != null) {
    let splideHome = new Splide('.slide-home.splide', {
        type: 'slider',
        lazyLoad: 'nearby',
        arrows: 'slider',
        pagination: false,
        preloadPages: 0,
        autoHeight: true,
        autoplay: false,
        breakpoints: {
            992: {
                pagination: true,
            }
        }
    }).mount();
}

if(typeof(document.querySelector('.slide-team.splide')) != 'undefined' && document.querySelector('.slide-team.splide') != null) {
    let splideTeam = new Splide('.slide-team.splide', {
        type: 'slider',
        lazyLoad: 'nearby',
        arrows: 'slider',
        pagination: false,
        preloadPages: 0,
        autoHeight: true,
        autoplay: false,
        perPage: 3,
        gap: '1.5rem',
        breakpoints: {
            992: {
                perPage: 2,
                pagination: true,
            },
            576: {
                perPage: 1,
            },
        }
    }).mount();
}

if(typeof(document.querySelector('.slide-media.splide')) != 'undefined' && document.querySelector('.slide-media.splide') != null) {
    let splideMedia = new Splide('.slide-media.splide', {
        type: 'slider',
        lazyLoad: 'nearby',
        arrows: 'slider',
        pagination: false,
        preloadPages: 0,
        autoHeight: true,
        autoplay: false,
        perPage: 4,
        perMove: 1,
        gap: '1em',
        breakpoints: {
            992: {
                perPage: 3,
            },
            576: {
                perPage: 2,
            },
        }
    }).mount();
}
